import React, { useCallback, useState } from 'react';
import { aboutme } from './data/aboutme.js';
import { site } from './data/site';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import useInView from '../hooks/useInView';
import useAboutPhotos from '../hooks/useAboutPhotos';

const builtIn = aboutme.Images.map((item) => ({
  src: item.src,
  alt: item.caption || null,
  legend: null,
}));

const AboutMe = () => {
  const [ref, inView] = useInView();
  const live = useAboutPhotos();
  const [failed, setFailed] = useState(() => new Set());
  const markFailed = useCallback((src) => {
    setFailed((current) => (current.has(src) ? current : new Set(current).add(src)));
  }, []);

  // Owner-managed photos when the API has them; otherwise, or if none of them load,
  // the built-in set. Same 4:3 frame either way, so nothing shifts when they swap.
  const usable = live ? live.filter((item) => !failed.has(item.src)) : [];
  const isLive = usable.length > 0;
  const photos = isLive ? usable : builtIn;
  const total = photos.length;

  return (
    <section
      id="about"
      aria-labelledby="about-title"
      ref={ref}
      className={`section about reveal${inView ? ' in-view' : ''}`}
    >
      <div className="container">
        <h2 id="about-title" className="section-title">
          {aboutme.Title}
        </h2>
        <div className="row g-4">
          <div className="col-12 col-lg-7">
            <p className="about-text">{aboutme.Main}</p>
          </div>
          <div className="col-12 col-lg-5">
            <div className="photo-wrap">
              <Carousel
                key={isLive ? 'live' : 'built-in'}
                infiniteLoop={true}
                autoPlay={false}
                showThumbs={false}
                showStatus={false}
                swipeable={true}
              >
                {photos.map((item, index) => (
                  <div key={item.src}>
                    <img
                      className="profile-img"
                      src={item.src}
                      loading="lazy"
                      alt={item.alt || item.legend || `${site.name}, ${index + 1} of ${total}`}
                      onError={isLive ? () => markFailed(item.src) : undefined}
                    />
                    {item.legend ? <p className="legend">{item.legend}</p> : null}
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
